import React, { Component } from 'react';
import CheckoutItem from './CheckoutItem';
import { Loader } from '../elements/index';

class ItemList extends Component {

    render() {

        const { items, removeItem, prices, content, filterData, firstLoginPurchaseView } = this.props;
        if( !items.length ) return <Loader />;
        
        return (
            <div>
                {
                    items.map( ( item, index ) => {
                        const product = filterData.filter( filterItem => filterItem.id === item.id )[ 0 ];
                        const _price = prices.filter( price => price.id === item.id )[ 0 ];
                        const _content = content.filter( content => content.id === item.id )[ 0 ];

                        if (!_content || !_price){
                            if( !_price ){
                                console.error('product/package doesnt exist or isnt for sale');
                                removeItem( product.id );
                            };
                            return <Loader key={index} />
                        };

                        if( firstLoginPurchaseView ) {
                            return (
                                <div key={ index }>
                                    <CheckoutItem
                                        id={ _content.id }
                                        name={ _content.name }
                                        price={ _price.price }
                                        firstLoginPurchaseView={ firstLoginPurchaseView }
                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div key={ index }>
                                    <CheckoutItem
                                        id={ _content.id }
                                        name={ _content.name }
                                        price={ _price.price }
                                        removeItem={ () => removeItem( product.id ) }
                                    />
                                </div>
                            );
                        }
                    } )
                }
            </div>
        );
    };
}

export default ItemList;



// WEBPACK FOOTER //
// src/client/components/common/transactions/ItemList.js